import {Injectable} from '@angular/core';
import {ApiCreateRuleRequestDto, ApiRuleResponseDto, ApiUpdateRuleRequestDto} from '@birco/rainmesh-api';
import {RuleConditionConverter} from './rule-condition.converter';
import {RuleActionConverter} from './rule-action.converter';
import {RuleFormModel} from '../models/rule-form-model.interface';
import {RuleViewModel} from '../models/rule-view-model.interface';

@Injectable({
  providedIn: 'root'
})
export class RuleConverter {

  static toRequestDto(formDto: RuleFormModel): ApiCreateRuleRequestDto | ApiUpdateRuleRequestDto {
    const conditions = RuleConditionConverter.toRequestDtoList(formDto.conditions);
    const orConditions = RuleConditionConverter.toRequestDtoList(formDto.orConditions);
    let formula = `(${
      conditions.map((it) =>
        'id' in it && !!it.id
          ? it.id
          : it.clientStubId
      ).join(' && ')
    })`;

    if (orConditions.length > 0) {
      formula += ` || (${
        orConditions.map((it) => it.clientStubId).join(' && ')
      })`;
    }

    return {
      name: formDto.name,
      isActive: true, // Default value
      isReversible: true, // Default value
      conditions: [
        ...conditions,
        ...orConditions,
      ],
      actions: RuleActionConverter.toRequestDtoList(formDto.actions),
      formula: formula,
    }
  }

  static toFormModel(ruleResponseDto: ApiRuleResponseDto): RuleFormModel {
    const formulaParts = ruleResponseDto.formula.split('||');
    const conditionsFormulaPart = formulaParts[0];
    const orConditionsFormulaPart = formulaParts.length > 1 ? formulaParts[1] : '';

    const conditions = ruleResponseDto.conditions.filter((it) =>
      conditionsFormulaPart.includes(it.id)
    );
    const orConditions = ruleResponseDto.conditions.filter((it) =>
      orConditionsFormulaPart.includes(it.id)
    );

    return {
      id: ruleResponseDto.id,
      name: ruleResponseDto.name,
      actions: RuleActionConverter.toFormModelList(ruleResponseDto.actions),
      conditions: RuleConditionConverter.toFormModelList(conditions),
      orConditions: RuleConditionConverter.toFormModelList(orConditions),
    }
  }

  static toViewModel(ruleResponseDto: ApiRuleResponseDto): RuleViewModel {
    const formulaParts = ruleResponseDto.formula.split('||');
    const conditionsFormulaPart = formulaParts[0];
    const orConditionsFormulaPart = formulaParts.length > 1 ? formulaParts[1] : '';

    const conditions = ruleResponseDto.conditions.filter((it) =>
      conditionsFormulaPart.includes(it.id)
    );
    const orConditions = ruleResponseDto.conditions.filter((it) =>
      orConditionsFormulaPart.includes(it.id)
    );

    return {
      id: ruleResponseDto.id,
      isActive: ruleResponseDto.isActive,
      name: ruleResponseDto.name,
      isSystemRule: ruleResponseDto.isSystemRule,
      systemRuleType: ruleResponseDto.systemRuleType,
      actions: RuleActionConverter.toViewModelList(ruleResponseDto.actions),
      conditions: RuleConditionConverter.toViewModelList(conditions),
      orConditions: RuleConditionConverter.toViewModelList(orConditions),
    }
  }
}
